var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import { Row, Col, Grid } from "react-bootstrap";
import { List as ListBase, Item, LoadMore, NoResults } from "@irati-web/reward/src/components/List";
import Tile from "@irati-web/reward/src/components/Tile";
import Loader from "@irati/utils/services/apollo/Loading/Loader";
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom";
import { DisablePointerEventsOnScroll } from "@irati/ui/src/Feed";
import padding from "@irati/ui/src/global/padding";
import RewardsQueryComponent from "@irati/reward/apollo/query/Rewards";
import { RewardStatus } from "@irati/reward/enums";
import CustomTile from "@irati-web/reward/src/components/CustomReward/Tile";
import { rewardTracking } from "@irati-tracking/reward";
import Layout from "@irati-web/recognition/src/components/Layout";
var List = styled(ListBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), padding.large);
var RecognitionAllRewards = /** @class */ (function (_super) {
    __extends(RecognitionAllRewards, _super);
    function RecognitionAllRewards() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hasRefetchingError: false
        };
        _this.onLoadMore = null;
        _this.handleScroll = function () {
            var atBottom = scrollAtBottom();
            var hasRefetchingError = _this.state.hasRefetchingError;
            if (atBottom && !hasRefetchingError) {
                _this.fetchMore();
            }
        };
        _this.handleNetworkStatusChange = function () {
            var hasRefetchingError = _this.state.hasRefetchingError;
            if (navigator.onLine && hasRefetchingError) {
                _this.fetchMore();
            }
        };
        _this.fetchMore = function () {
            if (_this.onLoadMore) {
                _this.setState({
                    hasRefetchingError: false
                });
                _this.onLoadMore().catch(function () {
                    _this.setState({
                        hasRefetchingError: true
                    });
                });
            }
        };
        return _this;
    }
    RecognitionAllRewards.prototype.componentDidMount = function () {
        window.addEventListener("online", this.handleNetworkStatusChange);
        window.addEventListener("scroll", this.handleScroll);
        rewardTracking.rewardsTabViewAllRewards();
    };
    RecognitionAllRewards.prototype.componentWillUnmount = function () {
        window.removeEventListener("online", this.handleNetworkStatusChange);
        window.removeEventListener("scroll", this.handleScroll);
    };
    RecognitionAllRewards.prototype.hasReceivedData = function (data) {
        return (data && "rewardCatalogueRewards" in data && "results" in data.rewardCatalogueRewards && data.rewardCatalogueRewards.results.length > 0);
    };
    RecognitionAllRewards.prototype.render = function () {
        var _this = this;
        var hasRefetchingError = this.state.hasRefetchingError;
        var params = {
            limit: 12,
            status: RewardStatus.ON,
            sortBy: "createdAt",
            sortDir: "DESC",
            rewardsForMyPackage: true
        };
        return (React.createElement(Layout, null,
            React.createElement(Grid, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(DisablePointerEventsOnScroll, null,
                            React.createElement(List, null,
                                React.createElement(RewardsQueryComponent, { useLoader: false, variables: params }, function (_a) {
                                    var data = _a.data, onLoadMore = _a.onLoadMore, refetch = _a.refetch, isLoading = _a.loading, error = _a.error, networkStatus = _a.networkStatus;
                                    var hasData = _this.hasReceivedData(data);
                                    var hasError = error || hasRefetchingError;
                                    var isRefetching = networkStatus === 3;
                                    _this.onLoadMore = !isLoading ? function () { return onLoadMore(); } : null;
                                    return isLoading && !isRefetching ? (React.createElement(Loader, null)) : (React.createElement(React.Fragment, null,
                                        data && hasData && (React.createElement(React.Fragment, null,
                                            React.createElement(Item, null,
                                                React.createElement(CustomTile, null)),
                                            data.rewardCatalogueRewards.results.map(function (reward) { return (React.createElement(Item, { key: reward.uuid },
                                                React.createElement(Tile, { id: "tile-" + reward.uuid, reward: reward }))); }))),
                                        isLoading && React.createElement(Loader, null),
                                        !isLoading && hasError && React.createElement(LoadMore, { onClick: error ? function () { return refetch(); } : _this.fetchMore }),
                                        !isLoading && !hasError && !hasData && React.createElement(NoResults, null)));
                                }))))))));
    };
    return RecognitionAllRewards;
}(Component));
export default RecognitionAllRewards;
var templateObject_1;
